import apiClient from './base.api'
const BASE_ENDPOINT = window.config.SUBSCRIPTION_BASE_ENDPOINT

/**
 * Redeem an AppSumo lifetime code.
 * - logged user: pass only `code` (the interceptor adds the JWT)
 * - new user: pass `code`, `email` and `password` -> the account is created together with
 *   the redeem and a validation email is sent.
 */
export const redeemAppSumoCodeApi = async(code, email = null, password = null) => {
  const payload = { code }

  if (email) {
    payload.email = email
    payload.password = password
  }

  const response = await apiClient.post(`${BASE_ENDPOINT}appsumo/redeem/`, payload, {
    skipAuth: !!email,
  })

  return response
}
